import type { Config, Service } from "@/types";
import configJson from "./config.json";
import servicesJson from "./services.json";

/** Datos del negocio (teléfono, horarios, slots, categorías). */
export const config: Config = configJson;

/** Catálogo de servicios con precios y duraciones. */
export const services: Service[] = servicesJson as Service[];
